import React, { useEffect, useState } from 'react';
import './GoldenNotification.css';

const GoldenNotification = ({ 
  isVisible, 
  onClose, 
  type = 'success', 
  title, 
  message, 
  duration = 3000 
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        setTimeout(onClose, 300); // Wait for animation to complete
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'info':
        return 'fas fa-info-circle';
      default:
        return 'fas fa-check-circle';
    }
  };

  const getTheme = () => {
    switch (type) {
      case 'success':
        return 'success-theme';
      case 'error':
        return 'error-theme';
      case 'warning':
        return 'warning-theme';
      case 'info':
        return 'info-theme';
      default:
        return 'success-theme';
    }
  };

  return (
    <div className={`golden-notification ${getTheme()} ${show ? 'show' : 'hide'}`}>
      <div className="notification-content">
        <div className="notification-icon">
          <i className={getIcon()}></i>
        </div>
        <div className="notification-text">
          <div className="notification-title">{title}</div>
          <div className="notification-message">{message}</div>
        </div>
        <button className="notification-close" onClick={() => {
          setShow(false);
          setTimeout(onClose, 300);
        }}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="notification-progress"></div>
    </div>
  );
};

export default GoldenNotification;
